<template>
  <div>
    <Card title="Referral Banner">
      <template v-slot:body>
        <div class="flex py-3">
          <div class="w-full p-3">
            <el-table :data="dataBanner" row-key="id" style="width: 100%">
              <el-table-column label="Image" key="image" width="750">
                <template slot-scope="scope">
                  <div class="static inline-block text-center container-action">
                    <img :src="scope.row.url" v-if="!!scope.row.url && ['referral_home_page', 'referral_premium_page'].includes(scope.row.type)" :style="{
                    width: '624px',
                    height: scope.row.type==='referral_premium_page' ? '192px' : '136px',
                  }" />
                    <img :src="scope.row.url" v-if="!!scope.row.url && scope.row.type==='referral_about_page'" :style="{
                    width: '720px',
                    height: '352px',
                  }" />
                    <img src="https://placehold.co/624x136" v-if="scope.row.url === null && scope.row.type==='referral_home_page'" />
                    <img src="https://placehold.co/624x192" v-if="scope.row.url === null && scope.row.type==='referral_premium_page'" />
                    <img src="https://placehold.co/720x352" v-if="scope.row.url === null && scope.row.type==='referral_about_page'" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Type" key="cover">
                <template slot-scope="scope">
                  {{ scope.row.type.replace(/_/g, ' ') }}
                </template>
              </el-table-column>
              <el-table-column label="Actions" align="right">
                <template slot-scope="scope">
                  <div class="static inline-block text-left container-action">
                    <VueCustomTooltip label="Edit" :position="'is-left'">
                      <button v-if="scope.row.id" @click="changeBanner(scope.row)" class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                        <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                      </button>
                      <button v-if="scope.row.id" @click="deleteBanner(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                        <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                      </button>
                      <button v-if="scope.row.id === null" @click="addBanner(scope.row.type)" class="p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                        <font-awesome-icon class="text-white" :icon="['fa', 'plus']" />
                      </button>
                    </VueCustomTooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </Card>
    <ModalDialog
      ref="sectionForm"
      :isShowingModal="isShowingModal"
      :title="titleModal"
      @toggleModal="isShowingModal = !isShowingModal"
      :labelSubmit="'Submit'"
      @save="submit()" >
      <template slot="body" >
        <form class="flex w-full overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="py-4">
            <form-item label='Image'>
              <input
                type="file"
                class="block border border-grey-light w-full p-3 rounded mb-4"
                name="profile_picture"
                accept="image/*"
                @change="onFileChange"
              />
              <div class="tooltip" >
                <img
                  style="width: 100%;margin: 0px auto;object-fit: contain;height: 200px;"
                  v-if="input.file"
                  :src="input.file"
                  @click="changeImage"
                />
                <span class="hint-tooltip" ><font-awesome-icon :icon="['fas', 'times-circle']" size="2x" @click="changeImage" /></span>
                <p class="text-xs text-left" >Input {{ this.textImageSize }} image in JPG or PNG. Max image size 1MB</p>
              </div>
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.input.file.$dirty && !$v.input.file.required"
                  text="Please select banner image."
                >
                </text-error>
                <text-error
                  v-if="isFileLarge"
                  text="Please using image lower than 1MB."
                >
                </text-error>
                <text-error
                  v-if="isFileWrongFormat"
                  text="Please use a valid image format"
                >
                </text-error>
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import helpersMixin from '@/mixins/helpers.mixins';
import { mapActions } from 'vuex';
import axios from 'axios';
import Vue from 'vue';
import ModalDialog from '@/components/Common/ModalDialog';
import { Button, FormItem, Input, TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

export default {
  name: 'ReferralBanner',
  mixins: [validationMixin, helpersMixin],
  data() {
    return {
      isFileLarge: false,
      isFileWrongFormat: false,
      isError: false,
      disabledBtn: true,
      isShowingModal: false,
      titleModal: '',
      input: {
        file: null,
        type: null,
        id: null,
      },
      data: {
        id: null,
        url: null,
      },
      dataBanner: [
        {
          id: null,
          type: 'referral_home_page',
          url: null,
        },
        {
          id: null,
          type: 'referral_premium_page',
          url: null,
        },
        {
          id: null,
          type: 'referral_about_page',
          url: null,
        },
      ],
    };
  },
  validations() {
    return {
      input: {
        file: {
          required,
        },
      },
    };
  },
  computed: {
    textImageSize() {
      switch (this.input.type) {
        case 'referral_home_page':
          return '624 x 136 px'
        case 'referral_premium_page':
          return '624 x 192 px'
        case 'referral_about_page':
          return '720 X 352 px'
        default:
          return ''
      }
    }
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    ...mapActions('AppSettingModule', [
      'requestCreateReferralBanner', 'requestDeleteReferralBanner', 'requestGetReferralBanner',
    ]),
    async getData() {
      const data = await this.requestGetReferralBanner();
      if (data) {
        this.dataBanner = this.dataBanner.map((b) => {
          const dataOrigin = data.find(d => d.type === b.type);
          if(dataOrigin){
            return { ...b, id: dataOrigin.id, url: dataOrigin.url };
          }
          return {...b}
        });
      }
    },
    resetState() {
      this.$v.$reset();
      this.isError = false;
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      this.input = Object.assign({}, { file: null, id: null });
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.isFileLarge && !this.isFileWrongFormat) {
        const cover = await axios({
          method: 'get',
          url: this.input.file,
          responseType: 'blob',
        }).then(this.processFileBlob);
        const data = {
          file: cover,
          type: this.input.type,
        };
        await this.requestCreateReferralBanner(data);
        this.resetState();
        this.isShowingModal = false;
        await this.getData();
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    onFileChange(e) {
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      const file = e.target.files[0];
      const image = new Image();
      image.onload = (ev) => {
        let widthSize = 624;
        let heightSize = 136;
        if(this.input.type === 'referral_premium_page'){
          heightSize = 192;
        }else if(this.input.type === 'referral_about_page'){
          widthSize = 720;
          heightSize = 352;
        }
        if ((image.width !== widthSize && image.height !== heightSize)) {
          this.$v.dirty = true;
          this.isFileWrongFormat = true;
        }
      };
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.input.file = URL.createObjectURL(file);
      image.src = this.input.file;
      this.disabledBtn = false;
    },
    changeImage() {
      this.input.file = null;
      this.disabledBtn = false;
    },
    addBanner(type) {
      this.resetState();
      this.input.type = type;
      this.titleModal = `Add Banner ${this.input.type.replace(/_/g, ' ')}`;
      this.isShowingModal = true;
    },
    changeBanner(row) {
      this.resetState();
      this.input.type = row.type;
      this.input.file = row.url;
      this.input.id = row.id;
      this.titleModal = `Edit Banner ${this.input.type.replace(/_/g, ' ')}`;
      this.isShowingModal = true;
    },
    async deleteBanner(row) {
      Vue.swal({
        title: 'Delete Data!',
        text: 'Are you sure to delete banner?',
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteReferralBanner({
            id: row.id,
          });
          await this.getData();
          this.$swal('Deleted', 'You successfully delete banner', 'success');
        }
      });
    },
  },
  components: { ModalDialog, Button,
    Card,
    FormItem, Input, TextError }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/ReferralBanner.vue